module.exports = __webpack_public_path__ + "img/moderate-01.3b9e96f0.png";